import React from "react";
import MyProfileForm from "./MyProfileForm";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const MyProfile = () => <MyProfileForm />;

export default MyProfile;
